import moment from "moment";
moment.locale('ru-RU');
window.moment = moment;
